module.exports = __webpack_public_path__ + "static/media/agencyRepair.62fead1a.svg";